import { TopToolbar, FilterButton, useTranslate } from 'react-admin';
import { useTheme } from '@mui/material';
import { CustomSortButton } from '@/components/global/buttons/CustomSortButton.jsx';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover.jsx';
import CustomExportButton from '@/components/global/buttons/CustomExportButton.jsx';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton.jsx';

export const PromotionalCampaingsActions = () => {
    const theme = useTheme();
    const translate = useTranslate();
    return (
        <TopToolbar
            sx={{
                '& .MuiFormControl-marginDense': {
                    margin: '0',
                },
                [theme.breakpoints.down('md')]: {
                    justifyContent: 'flex-start',
                },
                '& .filter-button': {
                    [theme.breakpoints.down('md')]: {
                        display: 'none',
                    },
                },
            }}
        >
            <CustomSortButton
                label={translate('common.sort')}
                options={[
                    { field: 'priority', order: 'DESC', label: translate('campaign.sorting.priorityDesc') },
                    { field: 'priority', order: 'ASC', label: translate('campaign.sorting.priorityAsc') },
                    { field: 'name', order: 'DESC', label: translate('campaign.sorting.nameDesc') },
                    { field: 'name', order: 'ASC', label: translate('campaign.sorting.nameAsc') },
                    { field: 'status', order: 'DESC', label: translate('campaign.sorting.statusDesc') },
                    { field: 'status', order: 'ASC', label: translate('campaign.sorting.statusAsc') },
                    { field: 'views', order: 'DESC', label: translate('campaign.sorting.viewsDesc') },
                    { field: 'views', order: 'ASC', label: translate('campaign.sorting.viewsAsc') },
                    { field: 'conversion', order: 'DESC', label: translate('campaign.sorting.conversionDesc') },
                    { field: 'conversion', order: 'ASC', label: translate('campaign.sorting.conversionAsc') },
                    { field: 'startDate', order: 'DESC', label: translate('campaign.sorting.periodDesc') },
                    { field: 'startDate', order: 'ASC', label: translate('campaign.sorting.periodAsc') },
                ]}
            />
            <FilterButton className='filter-button' data-label={translate('common.filter.add')} />
            <CustomToolbarActionsPopover>
                <CustomCreateButton label={translate('resources.campaign.labels.createCampaign')} />
                <CustomExportButton label={translate('resources.campaign.labels.exportCsv')} />
            </CustomToolbarActionsPopover>
        </TopToolbar>
    );
};
